import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { testDispatch } from '../api-client';
import type { WaterfallRow } from '../components/waterfallTypes';
import type { StatusMapping } from '../components/types';
import { settleWrite } from './unconfirmed-write';

interface TestDispatchPayload {
  campaignId: string;
  row_name: string;
  member_ids: string[];
  row: WaterfallRow;
  status_mapping: StatusMapping;
}

/** Resolves to `{ unconfirmed: true }` when the test sends may have gone out but the response was unreadable or cut off. */
export function useTestDispatch() {
  const { apiFetch } = useApi();
  return useMutation({
    mutationFn: ({ campaignId, ...payload }: TestDispatchPayload) =>
      settleWrite(() => testDispatch(apiFetch, campaignId, payload), () => undefined),
  });
}
